import React, { useRef, useEffect } from 'react';
import Card from '../Card/'; // Import Card component
import './Carousel.css';

const Carousel = ({ listings }) => {
    // Take only the first 3 listings
    const displayListings = listings.slice(0, 3);

    const scrollRef = useRef(null);
    const middleCardRef = useRef(null);

    useEffect(() => {
        if (window.innerWidth <= 600 && middleCardRef.current) {
            middleCardRef.current.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        }
    }, [listings]);

    return (
        <div className="carousel-container">
            <div className="carousel-scroll" ref={scrollRef}>
                {displayListings.map((listing, index) => {
                    const price = Math.ceil(listing.price);
                    return (
                        <div
                            key={index}
                            className="carousel-card-wrapper"
                            ref={index === 1 ? middleCardRef : null}
                            style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                        >
                            <Card 
                                card={listing.cert} 
                                price={listing.price}
                                hideDetails={true} 
                                isHomepage={true}
                            />
                            <div className="carousel-featured-price">${price.toLocaleString()}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Carousel;
